export default __webpack_public_path__ + "static/media/sub-category-eventsAndVenues-privateEventSpace.e892b246.jpg";